<div class="dialog-content padding-40">
	<!--Title-->
	<div class="text-align-center margin-bottom-20">
		<ngx-skeleton-loader [theme]="{ width: '380px', 'border-radius': '0', height: '28px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '300px', 'border-radius': '0', height: '28px' }"></ngx-skeleton-loader>
	</div>

	<!--Unsupported Sleeves-->
	<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
	<div class="margin-bottom-20">
		<ngx-skeleton-loader [theme]="{ width: '280px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
		<div class="grid margin-top-10 ">
			<div class="row">
				<div class="col-12">
					<ngx-skeleton-loader [theme]="{ width: '130px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
				</div>
				<div class="col-12">
					<ngx-skeleton-loader [theme]="{ width: '120px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
				</div>
			</div>
			<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
			<div class="row">
				<div class="col-12 ">
					<ngx-skeleton-loader [theme]="{ width: '110px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
				</div>
				<div class="col-12">
					<ngx-skeleton-loader [theme]="{ width: '130px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
				</div>
			</div>
			<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
			<div class="row">
				<div class="col-12 ">
					<ngx-skeleton-loader [theme]="{ width: '140px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
				</div>
				<div class="col-12">
					<ngx-skeleton-loader [theme]="{ width: '110px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
				</div>
			</div>
			<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
		</div>
	</div>

	<!--Unsupported Securities-->
	<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
	<div class="margin-bottom-20">
		<ngx-skeleton-loader [theme]="{ width: '240px', 'border-radius': '0', height: '28px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '80px', 'border-radius': '0', height: '20px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
	</div>

	<!--Asset Classes-->
	<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '3px' }"></ngx-skeleton-loader>
	<div class="margin-bottom-50">
		<ngx-skeleton-loader [theme]="{ width: '340px', 'border-radius': '0', height: '28px' }"></ngx-skeleton-loader>
		<ngx-skeleton-loader [theme]="{ width: '540px', 'border-radius': '0', height: '40px' }"></ngx-skeleton-loader>
	</div>

	<!--Continue Button-->
	<div class="pull-right margin-bottom-20">
		<ngx-skeleton-loader [theme]="{ width: '133px', 'border-radius': '0', height: '45px' }"></ngx-skeleton-loader>
	</div>
</div>
